import React from "react";
interface Props {
  customizationUrl: string;
  itemNumber: string;
}
const CustomizeButton = ({
  customizationUrl,
  itemNumber
}: Props) => {
  return <div className="add-to-cart" data-sentry-component="CustomizeButton" data-sentry-source-file="CustomizeButton.tsx">
      <div className="btn-container">
        <a href={customizationUrl || `/customized-products/${itemNumber.toLowerCase()}/`}>
          <button type="button" className="btn btn-block btn-custom btn-small">
            Customize Now
          </button>
        </a>
      </div>
    </div>;
};
export default CustomizeButton;